import { AfterViewInit, Directive, ElementRef } from "@angular/core";
import Scrollbar from "smooth-scrollbar";

@Directive({
  selector: "[appSlimScroll]"
})
export class SlimScrollDirective implements AfterViewInit {
  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    Scrollbar.init(this.el.nativeElement);
  }
}
